/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { XCircleIcon16Light } from './XCircleIcon16Light';
import { XCircleIcon16Regular } from './XCircleIcon16Regular';
import { XCircleIcon16Solid } from './XCircleIcon16Solid';
import { XCircleIcon20Light } from './XCircleIcon20Light';
import { XCircleIcon20Regular } from './XCircleIcon20Regular';
import { XCircleIcon20Solid } from './XCircleIcon20Solid';
import { XCircleIcon24Regular } from './XCircleIcon24Regular';
import { XCircleIcon24Solid } from './XCircleIcon24Solid';
import { XCircleIcon32Regular } from './XCircleIcon32Regular';
import { XCircleIcon64Regular } from './XCircleIcon64Regular';
var sizes = {
    16: {
        light: XCircleIcon16Light,
        regular: XCircleIcon16Regular,
        solid: XCircleIcon16Solid,
    },
    20: {
        light: XCircleIcon20Light,
        regular: XCircleIcon20Regular,
        solid: XCircleIcon20Solid,
    },
    24: {
        regular: XCircleIcon24Regular,
        solid: XCircleIcon24Solid,
    },
    32: {
        regular: XCircleIcon32Regular,
    },
    64: {
        regular: XCircleIcon64Regular,
    },
};
export var XCircleIcon = forwardRef('XCircleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
